import FAQAccordion from "./FAQAccordion";
import { HomeContent } from "../data/homeContent";

type FAQProps = { faq: HomeContent["faq"] };

const FAQ = ({ faq }: FAQProps) => (
  <FAQAccordion id="faq" eyebrow={faq.eyebrow} heading={faq.heading} items={faq.items} />
);

export default FAQ;
